import { ReactComponent as FacebookIcon } from 'app/assets/images/facebook.svg';
import { ReactComponent as TwitterIcon } from 'app/assets/images/twitter.svg';
import { ReactComponent as YoutubeIcon } from 'app/assets/images/youtube.svg';
import { ReactComponent as SnapChatIcon } from 'app/assets/images/snapchat.svg';
import { ReactComponent as TelegramIcon } from 'app/assets/images/telegram.svg';
import { ReactComponent as InstagramIcon } from 'app/assets/images/instagram.svg';
import { ReactComponent as TikTokIcon } from 'app/assets/images/tiktok.svg';
import { ReactComponent as ExclamationIcon } from 'app/assets/images/exclamation.svg';
import { ReactComponent as DashboardIcon } from 'app/assets/images/dashboard.svg';
import { ReactComponent as NewsIcon } from 'app/assets/images/news.svg';
import { ReactComponent as TrendsIcon } from 'app/assets/images/trends.svg';
import { ReactComponent as BookmarkIcon } from 'app/assets/images/bookmark.svg';
import { ReactComponent as UsersIcon } from 'app/assets/images/users.svg';
import { ReactComponent as UserImg } from 'app/assets/images/userImg.svg';
import { ReactComponent as EmptyImg } from 'app/assets/images/defaultImg.svg';
import { ReactComponent as HashtagsIcon } from 'app/assets/images/hashtags.svg';
import { ReactComponent as SetsIcon } from 'app/assets/images/sets.svg';
import { ReactComponent as InfluencersIcon } from 'app/assets/images/influencers.svg';
import { ReactComponent as ChannelsIcon } from 'app/assets/images/channels.svg';
import { ReactComponent as ReportsIcon } from 'app/assets/images/reports.svg';
import { ReactComponent as SystemIcon } from 'app/assets/images/system.svg';
import { ReactComponent as AddIcon } from 'app/assets/images/plus.svg';
import { ReactComponent as DeleteIcon } from 'app/assets/images/deleteIcon2.svg';
import { ReactComponent as LockIcon } from 'app/assets/images/lockIcon.svg';
import { ReactComponent as ExpandIcon } from 'app/assets/images/expand.svg';
import { ReactComponent as CountryIcon } from 'app/assets/images/countryIcon.svg';
import { ReactComponent as PlatformIcon } from 'app/assets/images/platform.svg';
import { ReactComponent as DateTo } from 'app/assets/images/date_to.svg';
import { ReactComponent as DateFrom } from 'app/assets/images/date_from.svg';
import { ReactComponent as SubmitIcon } from 'app/assets/images/submit.svg';
import { ReactComponent as ResetIcon } from 'app/assets/images/reset.svg';
import { ReactComponent as DateIcon } from 'app/assets/images/date_to.svg';
import { ReactComponent as QuestionIcon } from 'app/assets/images/questionIcon.svg';
import { ReactComponent as SearchIcon } from 'app/assets/images/search.svg';
import { ReactComponent as CloseIcon } from 'app/assets/images/closeIcon.svg';
import { ReactComponent as HelpIcon } from 'app/assets/images/help.svg';
import { ReactComponent as LanguageIcon } from 'app/assets/images/language.svg';
import { ReactComponent as HashtagIcon } from 'app/assets/images/hashtag.svg';
import { ReactComponent as TrendingIcon } from 'app/assets/images/trending.svg';
import { ReactComponent as EyeIcon } from 'app/assets/images/eye.svg';
import { ReactComponent as FemaleIcon } from 'app/assets/images/female.svg';
import { ReactComponent as MaleIcon } from 'app/assets/images/male.svg';
import { ReactComponent as RestartIcon } from 'app/assets/images/restart.svg';
import { ReactComponent as SettingsIcon } from 'app/assets/images/settings.svg';
import { ReactComponent as PaperIcon } from 'app/assets/images/paper.svg';
import { ReactComponent as PlusIcon } from 'app/assets/images/plusIcon.svg';
import { ReactComponent as LikeIcon } from 'app/assets/images/like.svg';
import { ReactComponent as DisLikeIcon } from 'app/assets/images/dislike.svg';
import { ReactComponent as UploadIcon } from 'app/assets/images/upload.svg';
import { ReactComponent as MessageIcon } from 'app/assets/images/message.svg';
import { ReactComponent as LeftArrowIcon } from 'app/assets/images/left-arrow.svg';
import { ReactComponent as RightArrowIcon } from 'app/assets/images/right-arrow.svg';
import { ReactComponent as CollapseIcon } from 'app/assets/images/expandIcon.svg';
import { ReactComponent as VideoIcon } from 'app/assets/images/videoIcon.svg';
import { ReactComponent as CurlyArrowIcon } from 'app/assets/images/curlyArrowIcon.svg';
import { ReactComponent as OuterIcon } from 'app/assets/images/outerIcon.svg';
import { ReactComponent as CategoryIcon } from 'app/assets/images/categoryIcon.svg';
import { ReactComponent as AnalyzedInfIcon } from 'app/assets/images/analyzedInfIcon.svg';
import { ReactComponent as TotalInfCategories } from 'app/assets/images/totalCategoriesIcon.svg';
import { ReactComponent as TotalInf } from 'app/assets/images/totalInfIcon.svg';
import { ReactComponent as InfTwitter } from 'app/assets/images/infTwitter.svg';
import { ReactComponent as InfGroup } from 'app/assets/images/infoGroupIcon.svg';
import { ReactComponent as InfMapIcon } from 'app/assets/images/infMapIcon.svg';
import { ReactComponent as TrashIcon } from 'app/assets/images/trashIcon.svg';
import { ReactComponent as EditIcon } from 'app/assets/images/editIcon.svg';
import { ReactComponent as ChartIcon } from 'app/assets/images/chartIcon.svg';
import { ReactComponent as VerifiedIcon } from 'app/assets/images/verified.svg';
import { ReactComponent as CalenderIcon } from 'app/assets/images/calender.svg';
import { ReactComponent as SubscribersIcon } from 'app/assets/images/subscribers.svg';
import { ReactComponent as UploadVideoIcon } from 'app/assets/images/upload-video.svg';
import { ReactComponent as EyeTimeIcon } from 'app/assets/images/eye-time.svg';
import { ReactComponent as FollowingIcon } from 'app/assets/images/following-icon.svg';
import { ReactComponent as FollowerIcon } from 'app/assets/images/follower-icon.svg';
import { ReactComponent as TweetsInterval } from 'app/assets/images/tweets-interval.svg';
import { ReactComponent as ClockIcon } from 'app/assets/images/clock.svg';
import { ReactComponent as BookIcon } from 'app/assets/images/book.svg';
import { ReactComponent as PlayIcon } from 'app/assets/images/play.svg';
import { ReactComponent as SaveIcon } from 'app/assets/images/saveIcon.svg';
import { ReactComponent as CancelIcon } from 'app/assets/images/cancelIcon.svg';
import { ReactComponent as SmallRightArrowIcon } from 'app/assets/images/right-arrow-small.svg';
import { ReactComponent as HistoryIcon } from 'app/assets/images/historyIcon.svg';
import { ReactComponent as VS } from 'app/assets/images/V.S.svg';
import { ReactComponent as PositiveIcon } from 'app/assets/images/positiveRectangle.svg';
import { ReactComponent as NeutralIcon } from 'app/assets/images/neutralRectangle.svg';
import { ReactComponent as NegativeIcon } from 'app/assets/images/negativeRectangle.svg';
import { ReactComponent as TopArrowIcon } from 'app/assets/images/topArrow.svg';
import { ReactComponent as UnnecessaryIcon } from 'app/assets/images/unnecessaryIcon.svg';
import { ReactComponent as AnalyzeIcon } from 'app/assets/images/analyze.svg';
import { ReactComponent as SmallUploadIcon } from 'app/assets/images/small-upload-icon.svg';
import { ReactComponent as OpenFileIcon } from 'app/assets/images/open-file-icon.svg';
import { ReactComponent as SetCreatedByIcon } from 'app/assets/images/setCreatedByIcon.svg';
import { ReactComponent as SetTrashIcon } from 'app/assets/images/setTrashIcon.svg';
import { ReactComponent as SetNumberWords } from 'app/assets/images/setNumberWords.svg';
import { ReactComponent as AnalyzedIcon } from 'app/assets/images/analyzed-icon.svg';
import { ReactComponent as UnAnalyzedIcon } from 'app/assets/images/un-analyzed-icon.svg';
import { ReactComponent as UnNecessaryIcon } from 'app/assets/images/un-necessary-icon.svg';
import { ReactComponent as TrendingHashtagIcon } from 'app/assets/images/trending-icon.svg';
import { ReactComponent as BlockedUsers } from 'app/assets/images/blockedUsers.svg';
import { ReactComponent as ActiveUsers } from 'app/assets/images/activeUsers.svg';
import { ReactComponent as Users } from 'app/assets/images/usersIcon.svg';
import { ReactComponent as NotificationIcon } from 'app/assets/images/notificationIcon.svg';
import { ReactComponent as HelpoutlineIcon } from 'app/assets/images/helpoutlineIcon.svg';
import { ReactComponent as BlockIcon } from 'app/assets/images/blockIcon.svg';
import { ReactComponent as UnBlockIcon } from 'app/assets/images/unBlockIcon.svg';
import { ReactComponent as SourcesIcon } from 'app/assets/images/sourcesIcon.svg';
import { ReactComponent as BookmarkBigIcon } from 'app/assets/images/bookmarkIcon.svg';
import { ReactComponent as ChannelsBigIcon } from 'app/assets/images/channelsIcon.svg';
import { ReactComponent as ReportsBigIcon } from 'app/assets/images/reportsBigIcon.svg';
import { ReactComponent as AddToPermIcon } from 'app/assets/images/addToPermIcon.svg';
import { ReactComponent as UnBlock } from 'app/assets/images/unBlock.svg';
import { ReactComponent as Block } from 'app/assets/images/block.svg';
import { ReactComponent as MakeReport } from 'app/assets/images/makeReport.svg';
import { ReactComponent as HashIcon } from 'app/assets/images/hash-icon.svg';
import { ReactComponent as MergeIcon } from 'app/assets/images/mergeIcon.svg';
import { ReactComponent as AttachToParent } from 'app/assets/images/attachToParent.svg';
import { ReactComponent as TopicsIcon } from 'app/assets/images/topicsIcon.svg';
import { ReactComponent as NewSourcesIcon } from 'app/assets/images/newSourcesIcon.svg';
import { ReactComponent as PlayVideoIcon } from 'app/assets/images/playVideoIcon.svg';
import { ReactComponent as FollowersCount } from 'app/assets/images/followersCount.svg';
import { ReactComponent as TrendingHashtag } from 'app/assets/images/trendingHashIcon.svg';
import { ReactComponent as InfluencersHoverIcon } from 'app/assets/images/influencersIcon.svg';
import { ReactComponent as LoginPattern } from 'app/assets/images/Loginpattern.svg';
import { ReactComponent as CheckBoxIschecked } from 'app/assets/images/checkBoxIschecked.svg';
import { ReactComponent as AddICon } from 'app/assets/images/addIcon.svg';
import { ReactComponent as ViewICon } from 'app/assets/images/viewIcon.svg';
import { ReactComponent as ViewIconActive } from 'app/assets/images/viewIconActive.svg';
import { ReactComponent as GraphIcon } from 'app/assets/images/graphIcon.svg';
import { ReactComponent as TableIcon } from 'app/assets/images/tableIcon.svg';
import { ReactComponent as DownArrowIcon } from 'app/assets/images/DownArrow.svg';
import { ReactComponent as UpArrowIcon } from 'app/assets/images/upArrowIcon.svg';
import { ReactComponent as DotsIcon } from 'app/assets/images/dots.svg';
import { ReactComponent as Resume } from 'app/assets/images/resume.svg';
import { ReactComponent as VideoSidebarIcon } from 'app/assets/images/videoSidebarIcon.svg';
import { ReactComponent as TotalPostsIcon } from 'app/assets/images/totalPostsIcon.svg';
import { ReactComponent as TotalSourcesIcon } from 'app/assets/images/totalSourcesIcon.svg';
import { ReactComponent as TotalAuthorsIcon } from 'app/assets/images/totalAuthorsIcon.svg';
import { ReactComponent as CategoriesIcon } from 'app/assets/images/categoriesIcon.svg';
import { ReactComponent as AutomaticGrabbing } from 'app/assets/images/automatic-grab.svg';
import { ReactComponent as RssGrabbing } from 'app/assets/images/rss-grab.svg';
import { ReactComponent as ManualGrabbing } from 'app/assets/images/manual-grab.svg';
import { ReactComponent as NumOfArticlesIcon } from 'app/assets/images/NumOfArticles.svg';
import { ReactComponent as RemoveLinkageICon } from 'app/assets/images/linkageIcon.svg';
import { ReactComponent as PausedICon } from 'app/assets/images/activeIcon.svg';
import { ReactComponent as ActiveICon } from 'app/assets/images/pausedIcon.svg';
import { ReactComponent as LinkageIcon } from 'app/assets/images/linkage.svg';
import { ReactComponent as RelatedTagsIcon } from 'app/assets/images/relatedTagsIcon.svg';
import { ReactComponent as ProfileIconDd } from 'app/assets/images/profileIconDd.svg';
import { ReactComponent as SettingsIconDd } from 'app/assets/images/settingsIconDd.svg';
import { ReactComponent as LanguageIconDd } from 'app/assets/images/languageIconDd.svg';
import { ReactComponent as LogoutIconDd } from 'app/assets/images/logoutIconDd.svg';
import { ReactComponent as SmallEntityIcon } from 'app/assets/images/smallEntityIcon.svg';
import { ReactComponent as BluePlayArrowIcon } from 'app/assets/images/bluePlayArrowIcon.svg';
import { ReactComponent as EntitiesChannelIcon } from 'app/assets/images/entitiesChannelIcon.svg';
import { ReactComponent as EntityImg } from 'app/assets/images/entityImg.svg';
import { ReactComponent as ClockSmallIcon } from 'app/assets/images/clockSmallIcon.svg';
import { ReactComponent as SearchBigIcon } from 'app/assets/images/searchBigIcon.svg';
import { ReactComponent as VideoSharpIcon } from 'app/assets/images/videoSharpIcon.svg';
import { ReactComponent as InstaShareIcon } from 'app/assets/images/instagram_share.svg';
import { ReactComponent as CalendarIcon } from 'app/assets/images/calendarIcon.svg';
import { ReactComponent as OrganizationsIcon } from 'app/assets/images/organizationsIcon.svg';
import { ReactComponent as DownloadIcon } from 'app/assets/images/downloadIcon.svg';
import { ReactComponent as DownloadActionIcon } from 'app/assets/images/download.svg';
import { ReactComponent as SubOrganizations } from 'app/assets/images/sub_organizations.svg';
import { ReactComponent as TotalPartnerships } from 'app/assets/images/partnerships.svg';
import { ReactComponent as NewsSquareDefaultImg } from 'app/assets/images/NewsSquareDefaultImg.svg';
import { ReactComponent as LangIcon } from 'app/assets/images/langIcon.svg';
import { ReactComponent as UserNetworkIcon } from 'app/assets/images/userNetworkIcon.svg';
import { ReactComponent as UserIcon } from 'app/assets/images/userIcon.svg';
import { ReactComponent as ImportantIcon } from 'app/assets/images/importantIcon.svg';
import { ReactComponent as UnimportantIcon } from 'app/assets/images/unimportantIcon.svg';
import { ReactComponent as MarkedImportantIcon } from 'app/assets/images/markedImportantIcon.svg';
import { ReactComponent as LatestUpdateIcon } from 'app/assets/images/latestUpdateIcon.svg';
import { ReactComponent as MarkedImportantLarg } from 'app/assets/images/MarkedImportantLarg.svg';
import { ReactComponent as DirectionIcon } from 'app/assets/images/directionIcon.svg';
import { ReactComponent as SetUsage } from 'app/assets/images/setUsage.svg';
import { ReactComponent as NewsArticle } from 'app/assets/images/NewsArticle.svg';
import { ReactComponent as NewsTotalSources } from 'app/assets/images/NewsTotalSources.svg';
import { ReactComponent as FiveHundered } from 'app/assets/images/FiveHundered.svg';
import { ReactComponent as UpArrow } from 'app/assets/images/Uparrow2.svg';
import { ReactComponent as TranslateWithoutHoveringIcon } from 'app/assets/images/translateWithoutHovering.svg';
import { ReactComponent as LeftArrow } from 'app/assets/images/arrow-left.svg';
import { ReactComponent as RightArrow } from 'app/assets/images/arrow-right.svg';
import { ReactComponent as HideIcon } from 'app/assets/images/hideIcon.svg';
import { ReactComponent as LargeVerfiedBlue } from 'app/assets/images/largeVerfiedBlue.svg';
import { ReactComponent as SettingIcon } from 'app/assets/images/settingIcon.svg';
import { ReactComponent as DragIcon } from 'app/assets/images/dragIcon.svg';
import { ReactComponent as DotIcon } from 'app/assets/images/dot.svg';
import { ReactComponent as ColorPickerIcon } from 'app/assets/images/colorPickerIcon.svg';
import { ReactComponent as ImageEditIcon } from 'app/assets/images/imageedit.svg';
import { ReactComponent as CropIcon } from 'app/assets/images/cropicon.svg';
import { ReactComponent as RatioIcon } from 'app/assets/images/ratioicon.svg';
import { ReactComponent as MinusIcon } from 'app/assets/images/minus.svg';
import { ReactComponent as RotateIcon } from 'app/assets/images/rotate.svg';
import { ReactComponent as MakeCopyIcon } from 'app/assets/images/makecopy.svg';
import { ReactComponent as Active } from 'app/assets/images/active.svg';
import { ReactComponent as Deactive } from 'app/assets/images/deactive.svg';
import { ReactComponent as CommentsIcon } from 'app/assets/images/commentsIcon.svg';
import { ReactComponent as NotificationDotsIcon } from 'app/assets/images/NotificationDotsIcon.svg';
import { ReactComponent as BigNotificationIcon } from 'app/assets/images/bigNotificationIcon.svg';
import { ReactComponent as SuccessIcon } from 'app/assets/images/success.svg';
import { ReactComponent as ErrorIcon } from 'app/assets/images/error.svg';
import { ReactComponent as BigExclamationIcon } from 'app/assets/images/bigExclamationIcon.svg';
import { ReactComponent as SmallHashtagIcon } from 'app/assets/images/smallHashtagIcon.svg';
import { ReactComponent as SelectedIcon } from 'app/assets/images/selectedIcon.svg';
import { ReactComponent as CloneIcon } from 'app/assets/images/cloneIcon.svg';
import { ReactComponent as Description } from 'app/assets/images/description.svg';
import { ReactComponent as NotificationImg } from 'app/assets/images/notification.svg';
import { ReactComponent as Linkedin } from 'app/assets/images/linkedin.svg';
import { ReactComponent as Reply } from 'app/assets/images/reply.svg';
import { ReactComponent as Ellipse_one } from 'app/assets/images/Ellipse 1.svg';
import { ReactComponent as Ellipse_two } from 'app/assets/images/Ellipse 2.svg';
import { ReactComponent as CommentTwitter } from 'app/assets/images/commentTwitter.svg';
import { ReactComponent as RetweetTwitter } from 'app/assets/images/retweetTwitter.svg';
import { ReactComponent as LoveTwitter } from 'app/assets/images/loveTwitter.svg';
import { ReactComponent as ExpandTwitter } from 'app/assets/images/expandTwitter.svg';
import { ReactComponent as SixDotsIcon } from 'app/assets/images/sixDots.svg';
import { ReactComponent as IconToGroupIcon } from 'app/assets/images/IconToGroup.svg';
import { ReactComponent as BigHeartIcon } from 'app/assets/images/bigHeart.svg';
import { ReactComponent as LastTweetClientIcon } from 'app/assets/images/lastTweetClient.svg';
import { ReactComponent as LastTweetPerDayIcon } from 'app/assets/images/lastTweetPerDay.svg';
import { ReactComponent as OldRegrabIcon } from 'app/assets/images/oldRegrabIcon.svg';
import { ReactComponent as TimeFrameIcon } from 'app/assets/images/timeFrame.svg';
import { ReactComponent as TransactionIcon } from 'app/assets/images/transaction.svg';
import { ReactComponent as InfluencerSentimentIcon } from 'app/assets/images/influencerSentiment.svg';
import { ReactComponent as ImpressionIcon } from 'app/assets/images/impression-report.svg';
import { ReactComponent as DivisionIcon } from 'app/assets/images/DivisionIcon.svg';
import { ReactComponent as ShowMap } from 'app/assets/images/showMap.svg';
import { ReactComponent as NotificationsActive } from 'app/assets/images/notifications-active.svg';
import { ReactComponent as NotificationsOff } from 'app/assets/images/notifications-off.svg';
import { ReactComponent as TwitterUnActiveIcon } from 'app/assets/images/feather-pause-circle.svg';
import { ReactComponent as FileIcon } from 'app/assets/images/file.svg';
import { ReactComponent as RecentActivityTime } from 'app/assets/images/recentActivityTime.svg';
import { ReactComponent as InsightfulIcon } from 'app/assets/images/insightful.svg';
import { ReactComponent as SupportIcon } from 'app/assets/images/support.svg';
import { ReactComponent as CelebrateIcon } from 'app/assets/images/celebrate.svg';
import { ReactComponent as LinkedinPlatformIcon } from 'app/assets/images/linkedinPlatform.svg';
import { ReactComponent as LinkedinLoveReactIcon } from 'app/assets/images/loveReact.svg';
import { ReactComponent as LinkedinSupportReactIcon } from 'app/assets/images/supportLinkedin.svg';
import { ReactComponent as LinkedinCeleberateReactIcon } from 'app/assets/images/Linkedin-Celebrate-Icon-ClappingHands500.svg';
import { ReactComponent as LinkedinInsightfulReactIcon } from 'app/assets/images/Linkedin-Insightful-Icon-Lamp500.svg';
import { ReactComponent as LinkedinLikeReactIcon } from 'app/assets/images/Linkedin-Like-Icon-Thumbup500.svg';
import { ReactComponent as LightModeIcon } from 'app/assets/images/lightModeIcon.svg';
import { ReactComponent as DarkModeIcon } from 'app/assets/images/darkModeIcon.svg';
import { ReactComponent as SuspendInsta } from 'app/assets/images/suspend_insta.svg';
import { ReactComponent as EmployeeIcon } from 'app/assets/images/employeeIcon.svg';
import { ReactComponent as OpenJobsIcon } from 'app/assets/images/open-job.svg';
import { ReactComponent as ReportLinkedinIcon } from 'app/assets/images/reportLinkedin.svg';
import { ReactComponent as AddReportIcon } from 'app/assets/images/addReportIcon.svg';
import { ReactComponent as ExportAsPDFIcon } from 'app/assets/images/export-as-pdf.svg';
import { ReactComponent as ReleaseNoteIcon } from 'app/assets/images/release_note_icon.svg';
import { ReactComponent as WarningIcon } from 'app/assets/images/warning-sign-svgrepo-com.svg';
import { ReactComponent as NotFoundIcon } from 'app/assets/images/notFound.svg';
import { ReactComponent as InstaComment } from 'app/assets/images/instaComment.svg';
import { ReactComponent as TweetsSidBarIcon } from 'app/assets/images/tweetsSidBar.svg';
import { ReactComponent as TweetRepliesIcon } from 'app/assets/images/tweetReplies.svg';
import { ReactComponent as RetweetTweetIcon } from 'app/assets/images/retweetTweetIcon.svg';
import { ReactComponent as TweetQuotesIcon } from 'app/assets/images/tweetQuotesIcon.svg';
import { ReactComponent as TweetClient } from 'app/assets/images/tweetClient.svg';
import { ReactComponent as TweetType } from 'app/assets/images/tweetType.svg';
import { ReactComponent as ReplyIcon } from 'app/assets/images/replyIcon.svg';
import { ReactComponent as QuoteIcon } from 'app/assets/images/quote.svg';
import { ReactComponent as TweetViewsIcon } from 'app/assets/images/tweetViews.svg';
import { ReactComponent as TweetRetweetIcon } from 'app/assets/images/tweetRetweetIcon.svg';
import { ReactComponent as TweetLikesIcon } from 'app/assets/images/tweetLikes.svg';
import { ReactComponent as TweetShareIcon } from 'app/assets/images/tweetShareIcon.svg';
import { ReactComponent as TweetBoxReplyIcon } from 'app/assets/images/tweetBoxReplyIcon.svg';
import { ReactComponent as TweetBoxQuoteIcon } from 'app/assets/images/tweetBoxQuoteIcon.svg';
import { ReactComponent as InstagramBigIcon } from 'app/assets/images/instagramBigicon.svg';
import { ReactComponent as LinkedinBigIcon } from 'app/assets/images/linkedinBigIcon.svg';
import { ReactComponent as VideoBigIcon } from 'app/assets/images/videoBigIcon.svg';
import { ReactComponent as SummaryPosts } from 'app/assets/images/summaryPosts.svg';
import { ReactComponent as PostsIcon } from 'app/assets/images/postsIcon.svg';
import { ReactComponent as AblumIcon } from 'app/assets/images/AblumIcon.svg';
import { ReactComponent as BigCommentIcon } from 'app/assets/images/BigComment.svg';
import { ReactComponent as BigPlayIcon } from 'app/assets/images/playIcon.svg';
import { ReactComponent as PinnedIcon } from 'app/assets/images/pinnedIcon.svg';
import { ReactComponent as SponsoredIcon } from 'app/assets/images/sponsored.svg';
import { ReactComponent as BigLocationIcon } from 'app/assets/images/BigLocation.svg';
import { ReactComponent as SmallPinIcon } from 'app/assets/images/smallPin.svg';
import { ReactComponent as SmallSponsoredIcon } from 'app/assets/images/smallSponsored.svg';
import { ReactComponent as SmallAlbumIcon } from 'app/assets/images/smallAlbumIcon.svg';
import { ReactComponent as ReelIcon } from 'app/assets/images/reelIcon.svg';
import { ReactComponent as PostImage } from 'app/assets/images/postImage.svg';
import { ReactComponent as SmallArrowIcon } from 'app/assets/images/smallArrowIcon.svg';
import { ReactComponent as SuspendTwitterIcon } from 'app/assets/images/suspendTweetIcon.svg';
import { ReactComponent as SuspendTiktokIcon } from 'app/assets/images/suspendTiktok.svg';
import { ReactComponent as SuspendYoutube } from 'app/assets/images/suspendYoutube.svg';
import { ReactComponent as SuspendInstagram } from 'app/assets/images/suspendInstagram.svg';
import { ReactComponent as SuspendFacebook } from 'app/assets/images/suspendFacebook.svg';
import { ReactComponent as MusicIcon } from 'app/assets/images/MusicIcon.svg';
import { ReactComponent as BigShareIcon } from 'app/assets/images/bigShare.svg';
import { ReactComponent as BigDownloadIcon } from 'app/assets/images/bigDownload.svg';
import { ReactComponent as CollectSectionsIcon } from 'app/assets/images/collect-sections-icon.svg';
import { ReactComponent as BigTikTokIcon } from 'app/assets/images/bigTikTokIcon.svg';
import { ReactComponent as ReactionsIcon } from 'app/assets/images/reactionsIcon.svg';
import { ReactComponent as PaidPromotionIcon } from 'app/assets/images/paidPromotion.svg';
import { ReactComponent as BigYoutubeIcon } from 'app/assets/images/Youtube_chart.svg';
export {
  PaidPromotionIcon,
  CollectSectionsIcon,
  BigShareIcon,
  BigDownloadIcon,
  MusicIcon,
  SuspendFacebook,
  SuspendInstagram,
  SuspendYoutube,
  SuspendTwitterIcon,
  SuspendTiktokIcon,
  SmallArrowIcon,
  PostImage,
  ReelIcon,
  SmallAlbumIcon,
  SmallPinIcon,
  SmallSponsoredIcon,
  BigLocationIcon,
  BigCommentIcon,
  BigPlayIcon,
  PinnedIcon,
  SponsoredIcon,
  AblumIcon,
  PostsIcon,
  SummaryPosts,
  VideoBigIcon,
  LinkedinBigIcon,
  InstagramBigIcon,
  TweetBoxQuoteIcon,
  TweetBoxReplyIcon,
  TweetShareIcon,
  TweetRetweetIcon,
  TweetLikesIcon,
  TweetViewsIcon,
  QuoteIcon,
  ReplyIcon,
  TweetsSidBarIcon,
  LightModeIcon,
  DarkModeIcon,
  AddReportIcon,
  ReportLinkedinIcon,
  OpenJobsIcon,
  EmployeeIcon,
  LinkedinCeleberateReactIcon,
  LinkedinInsightfulReactIcon,
  LinkedinLikeReactIcon,
  LinkedinSupportReactIcon,
  LinkedinLoveReactIcon,
  LinkedinPlatformIcon,
  InstaComment,
  CelebrateIcon,
  SupportIcon,
  InsightfulIcon,
  SuspendInsta,
  RecentActivityTime,
  NotificationsOff,
  NotificationsActive,
  DivisionIcon,
  ImpressionIcon,
  InfluencerSentimentIcon,
  TransactionIcon,
  TimeFrameIcon,
  OldRegrabIcon,
  LastTweetPerDayIcon,
  LastTweetClientIcon,
  BigHeartIcon,
  IconToGroupIcon,
  SixDotsIcon,
  TelegramIcon,
  SnapChatIcon,
  NotificationImg,
  CloneIcon,
  SelectedIcon,
  SmallHashtagIcon,
  BigExclamationIcon,
  BigNotificationIcon,
  NotificationDotsIcon,
  Active,
  DownloadActionIcon,
  Ellipse_two,
  Ellipse_one,
  Deactive,
  MakeCopyIcon,
  RotateIcon,
  MinusIcon,
  CropIcon,
  RatioIcon,
  DotIcon,
  ColorPickerIcon,
  SettingIcon,
  HideIcon,
  TranslateWithoutHoveringIcon,
  UpArrow,
  SetUsage,
  DirectionIcon,
  MarkedImportantLarg,
  LatestUpdateIcon,
  MarkedImportantIcon,
  UnimportantIcon,
  ImportantIcon,
  UserIcon,
  UserNetworkIcon,
  LangIcon,
  NewsSquareDefaultImg,
  TotalPartnerships,
  SubOrganizations,
  OrganizationsIcon,
  DownloadIcon,
  CalendarIcon,
  VideoSharpIcon,
  SearchBigIcon,
  ClockSmallIcon,
  EntitiesChannelIcon,
  BluePlayArrowIcon,
  ProfileIconDd,
  SettingsIconDd,
  LanguageIconDd,
  LogoutIconDd,
  SmallEntityIcon,
  RelatedTagsIcon,
  LockIcon,
  DeleteIcon,
  LinkageIcon,
  ActiveICon,
  PausedICon,
  RemoveLinkageICon,
  NumOfArticlesIcon,
  CategoriesIcon,
  TotalAuthorsIcon,
  TotalSourcesIcon,
  TotalPostsIcon,
  VideoSidebarIcon,
  Resume,
  DotsIcon,
  UpArrowIcon,
  DownArrowIcon,
  TableIcon,
  GraphIcon,
  ViewICon,
  AddICon,
  InstaShareIcon,
  CheckBoxIschecked,
  LoginPattern,
  TrendingHashtag,
  InfluencersHoverIcon,
  FollowersCount,
  PlayVideoIcon,
  AttachToParent,
  MergeIcon,
  AddToPermIcon,
  SourcesIcon,
  BookmarkBigIcon,
  ChannelsBigIcon,
  ReportsBigIcon,
  Users,
  UnBlock,
  Block,
  MakeReport,
  SetNumberWords,
  SetTrashIcon,
  SetCreatedByIcon,
  UnnecessaryIcon,
  PositiveIcon,
  NeutralIcon,
  NegativeIcon,
  VS,
  SaveIcon,
  CancelIcon,
  ClockIcon,
  TweetsInterval,
  FollowingIcon,
  FollowerIcon,
  ChartIcon,
  TrashIcon,
  EditIcon,
  InfMapIcon,
  AnalyzedInfIcon,
  TotalInf,
  TotalInfCategories,
  InfGroup,
  InfTwitter,
  CategoryIcon,
  OuterIcon,
  VideoIcon,
  CurlyArrowIcon,
  PlusIcon,
  MessageIcon,
  DisLikeIcon,
  LikeIcon,
  UploadIcon,
  CollapseIcon,
  CloseIcon,
  SearchIcon,
  QuestionIcon,
  DateTo,
  DateFrom,
  FacebookIcon,
  TwitterIcon,
  YoutubeIcon,
  InstagramIcon,
  TikTokIcon,
  ExclamationIcon,
  DashboardIcon,
  NewsIcon,
  TrendsIcon,
  BookmarkIcon,
  UsersIcon,
  UserImg,
  EmptyImg,
  HashtagsIcon,
  SetsIcon,
  InfluencersIcon,
  ChannelsIcon,
  ReportsIcon,
  SystemIcon,
  AddIcon,
  ExpandIcon,
  CountryIcon,
  PlatformIcon,
  SubmitIcon,
  ResetIcon,
  DateIcon,
  HelpIcon,
  LanguageIcon,
  HashtagIcon,
  TrendingIcon,
  EyeIcon,
  MaleIcon,
  FemaleIcon,
  RestartIcon,
  SettingsIcon,
  PaperIcon,
  LeftArrowIcon,
  RightArrowIcon,
  VerifiedIcon,
  CalenderIcon,
  SubscribersIcon,
  UploadVideoIcon,
  EyeTimeIcon,
  BookIcon,
  PlayIcon,
  SmallRightArrowIcon,
  HistoryIcon,
  TopArrowIcon,
  AnalyzeIcon,
  SmallUploadIcon,
  OpenFileIcon,
  AnalyzedIcon,
  UnAnalyzedIcon,
  UnNecessaryIcon,
  TrendingHashtagIcon,
  BlockedUsers,
  ActiveUsers,
  NotificationIcon,
  HelpoutlineIcon,
  BlockIcon,
  UnBlockIcon,
  HashIcon,
  TopicsIcon,
  NewSourcesIcon,
  AutomaticGrabbing,
  RssGrabbing,
  ManualGrabbing,
  NewsArticle,
  NewsTotalSources,
  FiveHundered,
  RightArrow,
  LeftArrow,
  LargeVerfiedBlue,
  DragIcon,
  EntityImg,
  ImageEditIcon,
  CommentsIcon,
  ViewIconActive,
  SuccessIcon,
  ErrorIcon,
  Description,
  Linkedin,
  Reply,
  CommentTwitter,
  RetweetTwitter,
  LoveTwitter,
  ExpandTwitter,
  ShowMap,
  TwitterUnActiveIcon,
  FileIcon,
  ExportAsPDFIcon,
  ReleaseNoteIcon,
  WarningIcon,
  NotFoundIcon,
  TweetRepliesIcon,
  RetweetTweetIcon,
  TweetQuotesIcon,
  TweetClient,
  TweetType,
  BigTikTokIcon,
  ReactionsIcon,
  BigYoutubeIcon
};
